module.exports = __webpack_public_path__ + "static/media/family_building_society.18f81e9e.jpg";